import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from './Icon';
import { Tooltip } from './Tooltip';

import styles from './fileUploader/FileUploader.module.scss';

export class FileUploader extends React.Component {
  constructor(props) {
    super(props);
    this.fileContainerElement = React.createRef();
  }

  handleDropInput = (event) => {
    const { onFileUploaded } = this.props;
    event.stopPropagation();
    event.preventDefault();

    if (this.fileContainerElement.current) {
      this.fileContainerElement.current.classList.remove(styles.droppable);
    }

    if (onFileUploaded) {
      onFileUploaded(event.dataTransfer.files);
    }
  };

  handleBrowseInput = (event) => {
    const { onFileUploaded } = this.props;

    if (onFileUploaded && event.target.files) {
      onFileUploaded(event.target.files);
    }
  };

  handleDragOver = (event) => {
    event.preventDefault();

    if (this.fileContainerElement.current) {
      this.fileContainerElement.current.classList.add(styles.droppable);
    }
  };

  handleDragEnd = (event) => {
    event.preventDefault();
    if (this.fileContainerElement.current) {
      this.fileContainerElement.current.classList.remove(styles.droppable);
    }
  };

  render() {
    const {
      className,
      browseFileButtonTitle,
      tooltipParams,
      isMultiple,
      isError,
      exampleDataURL,
      accept,
      title,
      notice,
      dragDropText,
      browseBtnClassName = '',
      isSampleAtBottom = false,
      additionalOptions,
    } = this.props;

    const fullClassNames = [styles.container];
    if (isError) {
      fullClassNames.push(styles.error);
    }
    if (className) {
      fullClassNames.push(className);
    }

    const label = (
      <label
        className={`btn-square _cornflower-blue _md ${browseBtnClassName} ${styles.browseButton}`}
        htmlFor={browseFileButtonTitle}
      >
        <span className="btn-content">
          <span className="btn-content__icon">
            <Icon name="Upload" />
          </span>
          <span>{browseFileButtonTitle}</span>
        </span>
      </label>
    );

    return (
      <div
        className={fullClassNames.join(' ')}
        onDrop={this.handleDropInput}
        onDragOver={this.handleDragOver}
        onDragLeave={this.handleDragEnd}
        ref={this.fileContainerElement}
      >
        {title && <div>{title}</div>}
        <input
          className={styles.fileInput}
          type="file"
          id={browseFileButtonTitle}
          onChange={this.handleBrowseInput}
          value=""
          multiple={isMultiple}
          accept={accept}
        />
        <div className="d-flex align-items-center mb-2">
          {tooltipParams ? (
            <Tooltip
              label={tooltipParams.label}
              auto={!tooltipParams.position}
              labelMaxWidth={tooltipParams.labelMaxWidth}
              position={tooltipParams.position}
            >
              {label}
            </Tooltip>
          ) : (
            label
          )}
          {exampleDataURL && !isSampleAtBottom ? (
            <a href={exampleDataURL} download className={styles.sample}>
              Sample File
            </a>
          ) : null}
        </div>
        <div className={styles.text}>{dragDropText}</div>
        <div className={styles.notice}>{notice}</div>
        {exampleDataURL && isSampleAtBottom ? (
          <a href={exampleDataURL} download className={`${styles.sample} ${styles.Last}`}>
            Sample File
          </a>
        ) : null}
        {additionalOptions && (
          <div className={styles.additionalOptions}>
            {additionalOptions}
          </div>
        )}
      </div>
    );
  }
}

FileUploader.defaultProps = {
  accept: '*',
  browseFileButtonTitle: 'Upload',
  dragDropText: 'Drag and Drop',
  notice: '',
};

FileUploader.propTypes = {
  className: PropTypes.string,
  browseFileButtonTitle: PropTypes.string,
  onFileUploaded: PropTypes.func,
  tooltipParams: PropTypes.shape({
    label: PropTypes.string,
    labelMaxWidth: PropTypes.number,
    position: PropTypes.string,
  }),
  isMultiple: PropTypes.bool,
  isError: PropTypes.bool,
  exampleDataURL: PropTypes.string,
  accept: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  notice: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  additionalOptions: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dragDropText: PropTypes.string,
  browseBtnClassName: PropTypes.string,
  isSampleAtBottom: PropTypes.bool,
};
